import { Store } from 'cw-ui-core';
import { changeSelectAllResources } from 'src/features/resources-assignment/slice';
import { RESOURCES_TYPES } from '../../constants';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';
import { isCorporateStructureFeatureEnabled } from 'src/features/resources-assignment/utils';

export const initialSortModel = [
    {
        field: 'name',
        sort: 'asc',
    },
];

export const transformResponseToDataGridRows = (response, isAdminRole) => {
    if (!response) return [];
    return response.map(row => {
        return {
            id: row.id,
            name: row.name || '',
            friendlyName: row.friendlyName || '',
            containerName: row.corpContainer?.name || '',
            primarySite: row.primarySite.name,
            status: row.activityStatus.activeFlag || false,
            ownershipType: row.ownershipType.name,
            totalSites: row.additionalInfo.totalSites || 0,
            isAdminRole,
        };
    });
};

export const populateSelectAllCompany = (totalCompanyCount, selectedCompaniesIds, rows) => {
    // check if current page companies are in selectedCompaniesIds
    const isRowIncludesSelectedCompanies = rows?.every(row => selectedCompaniesIds.includes(row.id));

    // if all companies in the current page are selected and total count matches, select all
    if (isRowIncludesSelectedCompanies && selectedCompaniesIds.length >= totalCompanyCount) {
        Store().dispatch(
            changeSelectAllResources({
                resourceType: RESOURCES_TYPES.COMPANY,
                value: true,
            })
        );
    } else if (!isRowIncludesSelectedCompanies) {
        Store().dispatch(
            changeSelectAllResources({
                resourceType: RESOURCES_TYPES.COMPANY,
                value: false,
            })
        );
    }
};

export const getFutureAllCompanyCheckboxTooltipMessage = (inheritedCompanies, hasAsioPlatformAppFullResourceAccess) => {
    if (inheritedCompanies?.length > 0) {
        return formatMessage(Locale.selectAllCompaniesCheckboxWithInheritedTooltip);
    } else if (!hasAsioPlatformAppFullResourceAccess) {
        return formatMessage(Locale.futureAllLimitedAccessTooltip);
    } else {
        return formatMessage(Locale.csGrantFutureCompaniesCheckboxTooltip);
    }
};

export const getSelectAllCompaniesCheckboxTooltipMessage = inheritedCompanies => {
    if (inheritedCompanies?.length > 0) {
        return formatMessage(Locale.selectAllCompaniesCheckboxWithInheritedTooltip);
    } else {
        return formatMessage(Locale.selectAllCompaniesCheckboxTooltip);
    }
};

export const getSelectAllCompanyDisabled = (isAdminRole, inheritedCompaniesLength) =>
    isAdminRole || inheritedCompaniesLength > 0;

const getSortFieldsMapping = () => {
    const mapping = {
        name: 'name',
        friendlyName: 'friendlyName',
        primarySite: 'primarySite.name',
        status: 'activityStatus.activeFlag',
        ownershipType: 'ownershipType.name',
        totalSites: 'additionalInfo.totalSites',
    };

    if (isCorporateStructureFeatureEnabled()) {
        mapping.containerName = 'corpContainer.name';
    }

    return mapping;
};

export const getTransformedSortModel = sortModel => {
    if (!sortModel?.length) {
        return [];
    }

    const sortFieldsMapping = getSortFieldsMapping();

    return sortModel.map(item => ({
        field: sortFieldsMapping[item.field] || item.field,
        sort: item.sort,
    }));
};

export const checkCompanyHasSetup = (rows, isLoading, filterModel) => {
    const noRecordsFound = rows?.length === 0 && !isLoading;
    const isFilterApplied = filterModel.items.length || filterModel.quickFilterValues.length;
    return noRecordsFound && !isFilterApplied;
};
